import { render, staticRenderFns } from "./WhyPage.vue?vue&type=template&id=d8e8e7f4&scoped=true&"
import script from "./WhyPage.vue?vue&type=script&lang=js&"
export * from "./WhyPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8e8e7f4",
  null
  
)

export default component.exports